module.exports = __webpack_public_path__ + "static/media/canvas_accents_active.ab761401.svg";